import React from 'react'

interface CalloutProps {
  callout?: string
}

export const Callout: React.FC<CalloutProps> = (props) => {
  const calloutTextPresent = props.callout !== null && props.callout !== ''

  const calloutText = (): string => {
    if (calloutTextPresent) {
      return props.callout as string
    } else {
      return 'NOT PROVIDED'
    }
  }

  const calloutClasses = (): string => {
    if (calloutTextPresent) {
      return 'color-pro-steel-grey-600 font-bold'
    } else {
      return 'color-pro-steel-grey-500'
    }
  }

  return (
    <div className={`pro-callout pro-rounded pro-text-xs color-pro-blue-700 display-inline-block ${calloutClasses()}`}>
      {calloutText()}
    </div>
  )
}
